'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// ./~/_es-errors@1.3.0@es-errors/index.js
// module id = 6xy3
// module chunks = 0